import React, {useEffect, useState} from "react";
import {titleize, objectMap} from "../../../javascripts/utils";
import TooltipTrigger from "../bootstrap/TooltipTrigger";
import {copyToClipboard} from "../../utils/utilsHelpers";

export default function ShareOptions({shareObj, itemId, itemType, itemUrl, extraContent}) {

    return (
        <>
            {objectMap(shareObj, (url, platform) => {
                return (
                    <TooltipTrigger id={`${itemType}_${itemId}_${platform}`} key={`${itemType}_${itemId}_${platform}`} placement={'top'} content={`Share on ${titleize(platform)}`}>
                        <a
                            href={url}
                            className={`text-${platform}`}
                            target={'_blank'}
                        >
                          <i className={`fab fa-${platform}`}></i>
                        </a>
                    </TooltipTrigger>
                )
            })}
            <TooltipTrigger id={`${itemType}_${itemId}_email`} key={`${itemType}_${itemId}_email`} placement={'top'} content={'Share via email'}>
                <a
                    href={`mailto:TYPE_EMAIL_HERE?body=${extraContent}&subject=${extraContent}`}
                    className={'link-medium'}
                    target={'_blank'}
                >
                    <i className={'fal fa-envelope'}></i>
                </a>
            </TooltipTrigger>
            <TooltipTrigger id={`${itemType}_${itemId}_copy`} key={`${itemType}_${itemId}_copy`} placement={'top'} content={'Copy link'}>
                <a
                    className={'link-medium'}
                    onClick={() => { copyToClipboard(itemUrl?.replace('__src__', 'copy'))}}
                >
                    <i className={'fal fa-link'}></i>
                </a>
            </TooltipTrigger>
        </>
    )
}
